import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { CommitteeMeetingDto, initializedCommitteeMeetingDto } from '../shared/dto/committee-meeting.dto';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { CommitteeMeetingService } from '../shared/committee-meeting.service';
import { CommitteeDto } from '../shared/dto/committee.dto';
import { CommitteeService } from '../shared/committee.service';
import { NotificationService } from 'src/app/shared';
import { NgForm } from '@angular/forms';
import { Location } from '@angular/common';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'wl-committee-meeting-edit',
  templateUrl: './committee-meeting-edit.component.html',
  styleUrls: ['./committee-meeting-edit.component.less'],
    standalone: false
})
export class CommitteeMeetingEditComponent implements OnInit, OnDestroy {
  @ViewChild('meetingForm') meetingForm: NgForm;

  committeeId: number;
  committeeMeetingId: number;
  committeeMeeting: CommitteeMeetingDto;
  committee: CommitteeDto;
  isSaving = false;

  private subscriptions = new Subscription();
  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _committeeMeetingService: CommitteeMeetingService,
    private _committeeService: CommitteeService,
    private _notificationService: NotificationService,
    private _location: Location,
    private _title: Title
  ) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this._route.params.subscribe((params) => {
        if (params.committeeId) {
          this.committeeId = parseInt(params.committeeId, 10);
          this.loadCommittee();
        }
        if (+params.meetingId) {
          this.committeeMeetingId = parseInt(params.meetingId, 10);
          this.loadMeeting();
        } else {
          this.initializeNewMeeting();
        }
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  save() {
    this.createOrUpdateMeeting().then(() => {
      this.returnToPreviousPage();
    });
  }

  saveAndContinue() {
    this.createOrUpdateMeeting().then(() => {
      this._title.setTitle(this.committeeMeeting.Committee.Name + ': ' + this.committeeMeeting.Title);
      this._notificationService.translateSuccess('committees.edit.committee-meetings.meeting-saved');
      this.meetingForm?.form?.markAsPristine();
      this._location.go(`/profiles/committee/${this.committeeId}/meeting/${this.committeeMeeting.MeetingID}`);
    });
  }

  cancel() {
    this.returnToPreviousPage();
  }

  private loadCommittee() {
    this._committeeService.get(this.committeeId).then((committee) => {
      this.committee = committee;
    });
  }

  private loadMeeting() {
    this._committeeMeetingService.get(this.committeeMeetingId).then((meeting) => {
      this.committeeMeeting = meeting;
      this._title.setTitle(meeting.Committee.Name + ': ' + meeting.Title);
    });
  }

  private initializeNewMeeting() {
    this.committeeMeeting = initializedCommitteeMeetingDto(this.committeeId);
  }

  private createOrUpdateMeeting(): Promise<void> {
    this.isSaving = true;
    let promise: Promise<void>;
    if (!this.committeeMeeting.MeetingID) {
      promise = this._committeeMeetingService.create(this.committeeMeeting).then((id) => {
        this.committeeMeeting.MeetingID = id;
      });
    } else {
      promise = this._committeeMeetingService.update(this.committeeMeeting);
    }

    return promise
      .catch((err) => {
        this._notificationService.httpError(err);
      })
      .finally(() => {
        this.isSaving = false;
      });
  }

  private returnToPreviousPage() {
    if (this._router.getCurrentNavigation()?.previousNavigation.finalUrl) {
      this._router.navigateByUrl(this._router.getCurrentNavigation().previousNavigation.finalUrl);
    } else {
      this._router.navigate(['profiles/committee', this.committeeId]);
    }
  }
}
